import React, { useEffect, useState } from 'react';
import { Typography, Button, TextField, CircularProgress, Modal, Box, FormControl, RadioGroup, FormControlLabel, Radio, FormLabel, Autocomplete, IconButton, List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { DataGridPro, GridToolbar } from '@mui/x-data-grid-pro';
import apiService from '../../../utlis/apiService';
import { useUser } from '../../../context/userContext';
import { Close as CloseIcon } from '@mui/icons-material';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '60%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    overflow: 'auto',
    maxHeight: '80%',
};

const MyTable = () => {
    const { permissions } = useUser();
    const [data, setData] = useState([]);
    const [totalResults, setTotalResults] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);
    const [paginationModel, setPaginationModel] = useState({
        pageSize: 50,
        page: 0,
    });
    const [selectedRow, setSelectedRow] = useState(null);
    const [currentBatch, setCurrentBatch] = useState(null);
    const [batchForwardModal, setBatchForwardModal] = useState(false);
    const [batchCloseModal, setBatchCloseModal] = useState(false);
    const [batchApproveModal, setBatchApproveModal] = useState(false);
    const [remark, setRemark] = useState('');
    const [selectedEsclateTo, setSelectedEsclateTo] = useState('');
    const [psychologicalCounselorsList, setPsychologicalCounselorsList] = useState([]);
    const [selectedAssignee, setSelectedAssignee] = useState('');
    const [academicCoordinatorList, setAcademicCoordinatorList] = useState([]);
    const [accountantList, setAccountantList] = useState([]);
    const [mentorList, setMentorList] = useState([]);
    const [centreManagerList, setCentreManagerList] = useState([]);
    const [meId, setMeId] = useState('');
    const [ticketActivityList, setTicketActivityList] = useState([]);
    const [ticketActivityModal, setTicketActivityModal] = useState(false);

    const pageOption = [10, 25, 50, 100];

    useEffect(() => {
        getData();
    }, [searchTerm, paginationModel]);

    const navigate = useNavigate();

    const getData = async () => {
        setLoading(true); // Start loading
        try {
            const response = await apiService.get('/student-ticket/list', {
                params: {
                    searchTerm: searchTerm,
                    page: paginationModel.page,
                    pageSize: paginationModel.pageSize,
                },
            });
            setData(response?.data?.tickets);
            setTotalResults(response?.data?.totalResults);
            setMeId(response?.data?.meId);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false); // Stop loading, whether success or error
        }
    };

    const createPress = () => {
        clearLocalStorageKeysWithSubstring("FormData");
        navigate('/dashboard/student-ticket/add');
    };

    function clearLocalStorageKeysWithSubstring(substring) {
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key.includes(substring)) {
                localStorage.removeItem(key);
            }
        }
    }

    const ticketForward = (row) => {
        setSelectedRow(row);
        setBatchForwardModal(true);

        const category = row?.admission?.category?.find(category => category._id === row.categoryObj);
        const runningBatch = category?.batch?.find(batch => batch.status === 'Running');
        const upcomingBatch = category?.batch?.find(batch => batch.status === 'Upcoming');
        const openForBatch = category?.batch?.find(batch => batch.status === 'Open For Enrollment');

        if(runningBatch) {
            setCurrentBatch(runningBatch);
        }
        else if(upcomingBatch) {
            setCurrentBatch(upcomingBatch);
        }
        else if(openForBatch) {
            setCurrentBatch(openForBatch);
        }
    }

    const handleForwardToChange = (e) => {
        setSelectedEsclateTo(e.target.value);
        getForwardToAuthority(e.target.value);
    }

    const getForwardToAuthority = async (authority) => {
        setLoading(true);
        try {
            const response = await apiService.get('/student-ticket/get/forward-authority', {
                params: {
                    authority: authority,
                },
            });
            if(authority === 'Psychological Counselor') {
                setPsychologicalCounselorsList(response?.data);
            }
            else if(authority === 'Academic Coordinator') {
                setAcademicCoordinatorList(response?.data);
            }
            else if(authority === 'Mentor') {
                setMentorList(response?.data);
            }
            else if(authority === 'Accountant') {
                setAccountantList(response?.data);
            }
            else if(authority === 'Centre Manager') {
                setCentreManagerList(response?.data);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false); // Stop loading, whether success or error
        }
    }

    const handleChangeAssignee = (value) => {
        setSelectedAssignee(value?._id);
    }

    const forwardTicketTo = async () => {
        try {
            if(!selectedEsclateTo) {
                alert('Choose any of the option to forward');
            }
            else if(selectedEsclateTo !== 'Sales Agent' && selectedAssignee === '') {
                alert('Select the assignee');
            }
            else if(remark.length < 150) {
                alert('Please enter remark with at least 150 characters');
            }
            else {
                const category = selectedRow.admission.category.find(category => category._id === selectedRow.categoryObj);

                const data = {
                    meId: meId,
                    to: selectedAssignee,
                    ticketId: selectedRow._id,
                    remark: remark,
                    type: 'forward',
                    selectedTo: selectedEsclateTo,
                    agentMail: category?.leadOwner
                }

                const response = await apiService.post('/student-ticket/forward-ticket', data);

                alert(response.data.message);
                setSelectedAssignee('');
                setSelectedEsclateTo('');
                setSelectedRow(null);
                setBatchForwardModal(false);
                getData();
            }
        }
        catch (error) {
            console.error(error);
        } finally {
            setLoading(false); // Stop loading, whether success or error
        }
    }

    const ticketClose = (row) => {
        setSelectedRow(row);
        setBatchCloseModal(true);
    }

    const closeTicket = async () => {
        try {
            if(remark.length < 150) {
                alert('Please enter remark with at least 150 characters');
            }
            else {
                const data = {
                    meId: meId,
                    ticketId: selectedRow._id,
                    remark: remark,
                    type: 'close',
                }

                const response = await apiService.post('/student-ticket/forward-ticket', data);

                alert(response.data.message);
                setBatchCloseModal(false);
                setSelectedRow(null);
                setRemark('');
                getData();
            }
        }
        catch (error) {
            console.error(error);
        } finally {
            setLoading(false); // Stop loading, whether success or error
        }
    }

    const ticketApprove = (row) => {
        setSelectedRow(row);
        setBatchApproveModal(true);
    }

    const approveTicket = async () => {
        try {
            if(remark.length < 150) {
                alert('Please enter remark with at least 150 characters');
            }
            else {
                const data = {
                    meId: meId,
                    ticketId: selectedRow._id,
                    remark: remark,
                    type: 'completed',
                }

                const response = await apiService.post('/student-ticket/forward-ticket', data);

                alert(response.data.message);
                setBatchApproveModal(false);
                setSelectedRow(null);
                setRemark('');
                getData();
            }
        }
        catch (error) {
            console.error(error);
        } finally {
            setLoading(false); // Stop loading, whether success or error
        }
    }

    const showForwardClose = (ticketOwner) => {
        let show = false;
        if(meId === ticketOwner)
            show = true;

        return show;
    }

    const ticketActivityView = (assignees) => {
        setTicketActivityList(assignees);
        setTicketActivityModal(true);
    }

    const formatDate = (date) => {
        if(date) {
            return new Date(date).toLocaleDateString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' });
        }
        else {
            return '-';
        }
    }

    const getActivities = (activity) => {
        let text = '';
        if(activity.status === 'Created') {
            text = `${formatDate(activity.assignedDate)} New Ticket created by ${activity?.assignedByMentor ? activity?.assignedByMentor.name : activity?.assignedBy?.name} (${activity?.assignedByMentor ? 'Mentor' : activity?.assignedBy?.role?.name})`;
        }
        else if(activity.status === 'Forward') {
            text = `${formatDate(activity.assignedDate)} Ticket forwarded by ${activity?.assignedByMentor ? activity?.assignedByMentor.name : activity?.assignedBy?.name} (${activity?.assignedByMentor ? 'Mentor' : activity?.assignedBy?.role?.name}) to ${activity?.salesAgent ? activity?.salesAgent : activity?.mentor ? activity?.mentor.name : activity?.user?.name} (${activity?.mentor ? 'Mentor' : activity?.user?.role?.name})`;
        }
        else if(activity.status === 'Close') {
            text = `${formatDate(activity.assignedDate)} Ticket closed by ${activity?.assignedByMentor ? activity?.assignedByMentor.name : activity?.assignedBy?.name} (${activity?.assignedByMentor ? 'Mentor' : activity?.assignedBy?.role?.name})`;
        }
        else if(activity.status === 'Completed') {
            text = `${formatDate(activity.assignedDate)} Ticket approved by ${activity?.assignedByMentor ? activity?.assignedByMentor.name : activity?.assignedBy?.name} (${activity?.assignedByMentor ? 'Mentor' : activity?.assignedBy?.role?.name})`;
        }

        return (
            <>
                <ListItem disablePadding>
                    <ListItemText primary={text} />
                </ListItem>
                <ListItem disablePadding >
                    <ListItemText secondary={`Remark: ${activity?.remark ?? '-'}`} />
                </ListItem>
            </>
        )
    }

    return (
        <div>
            <div style={{ flexDirection: 'row', justifyContent: 'space-between', display: 'flex' }}>
                <Typography variant="h4" gutterBottom>STUDENT TICKETS</Typography>
                {permissions.includes('createStudentTickets') && (
                    <Button variant="contained" color="primary" style={{ marginBottom: '16px' }} onClick={createPress}>
                        + Create Ticket
                    </Button>
                )}
            </div>
            <TextField
                label="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                fullWidth
                margin="normal"
                style={{ marginBottom: 10 }}
                size="small"
            />
            {loading ? ( // Show loader if loading
                <CircularProgress style={{ margin: '20px auto', display: 'block' }} />
            ) : (
                <div style={{ height: '70vh', width: '100%' }}>
                    <DataGridPro
                        rows={data}
                        getRowId={(row) => row._id}
                        columns={[
                            { field: 'name', headerName: 'Issue', flex: 1 },
                            { field: 'student', headerName: 'Student', flex: 1, valueGetter: (params) => params?.row?.student?.firstName + ' ' + params?.row?.student?.lastName + ' (' + params?.row?.student?.phoneNumber + ')' },
                            { field: 'course', headerName: 'Course', flex: 1, valueGetter: (params) => params?.row?.admission?.course?.name },
                            { field: 'category', headerName: 'Category', flex: 1, valueGetter: (params) => params?.row?.category?.name },
                            { field: 'type', headerName: 'Type', flex: 1 },
                            {
                                field: 'actions',
                                headerName: 'Action',
                                width: 400,
                                renderCell: (params) => (
                                    <>
                                        {permissions.includes('readStudentTicketActivity') && (
                                            <Button type="button" variant="outlined" onClick={() => ticketActivityView(params?.row?.assignees)}>View</Button>
                                        )}
                                        {showForwardClose(params?.row?.ticketOwner) ? 
                                            <>
                                                {permissions.includes('forwardStudentTickets') && (
                                                    <Button type="button" variant="outlined" style={{ marginLeft: 5 }} onClick={() => ticketForward(params?.row)}>Forward</Button>
                                                )}
                                                {permissions.includes('closeStudentTickets') && (
                                                    <Button type="button" variant="outlined" style={{ marginLeft: 5 }} onClick={() => ticketClose(params?.row)}>Close</Button>
                                                )}
                                                {permissions.includes('approveStudentTickets') && (
                                                    <Button type="button" variant="outlined" style={{ marginLeft: 5 }} onClick={() => ticketApprove(params?.row)}>Approve</Button>
                                                )}
                                            </>
                                        : ''}
                                    </>
                                ),
                            },
                        ]}
                        pagination
                        paginationModel={paginationModel}
                        rowCount={totalResults}
                        paginationMode="server"
                        slots={{ Toolbar: GridToolbar }}
                        onPaginationModelChange={setPaginationModel}
                        pageSizeOptions={pageOption}
                    />
                </div>
            )}

            <Modal
                open={batchForwardModal}
                onClose={() => setBatchForwardModal(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div>
                        <p>Issue: {selectedRow?.name}</p>
                        <p>Student: {selectedRow?.student?.firstName} {selectedRow?.student?.lastName}</p>
                        <p>Course: {selectedRow?.admission?.course?.name}</p>
                        <p>Category: {selectedRow?.category?.name}</p>
                        <p>Type: {selectedRow?.type}</p>
                        {selectedRow?.type === 'Scheme Change' ?
                            <>
                                <b>Scheme Change To Details: </b>
                                <p>Category: {selectedRow?.categoryTo?.name}</p>
                                <p>Status Type: {selectedRow?.statusType}</p>
                                <p>Mode: {selectedRow?.mode}</p>
                            </>
                        : ''}
                        <TextField 
                            label="Remark"
                            value={remark}
                            onChange={(e) => setRemark(e.target.value)}
                            multiline
                            minRows={2}
                            fullWidth
                            required
                            sx={{ marginBottom: '20px' }}
                        />
                        <FormControl>
                            <FormLabel id="ForwardTo">Forward To:</FormLabel>
                            <RadioGroup
                                row
                                aria-labelledby="ForwardTo"
                                name="row-radio-buttons-group"
                                value={selectedEsclateTo}
                                onChange={handleForwardToChange}
                            >
                                <FormControlLabel value="Psychological Counselor" control={<Radio />} label="Psychological Counselor" />
                                <FormControlLabel value="Academic Coordinator" control={<Radio />} label="Academic Coordinator" />
                                <FormControlLabel value="Mentor" control={<Radio />} label="Mentor" />
                                <FormControlLabel value="Accountant" control={<Radio />} label="Accountant" />
                                <FormControlLabel value="Sales Agent" control={<Radio />} label="Sales Agent" />
                                <FormControlLabel value="Centre Manager" control={<Radio />} label="Centre Manager" />
                            </RadioGroup>
                        </FormControl>
                        {selectedEsclateTo === 'Psychological Counselor' ?
                            <Autocomplete
                                id="psychological-counselor-autocomplete"
                                value={psychologicalCounselorsList.find(counselor => counselor._id === selectedAssignee)}
                                options={psychologicalCounselorsList}
                                getOptionLabel={(option) => option?.name}
                                onChange={(event, newValue) => handleChangeAssignee(newValue)}
                                loading={loading}
                                renderInput={(params) => (
                                    <TextField {...params} label="Psychological Counselor *" />
                                )}
                                sx={{ marginTop: '15px' }}
                                size="small"
                            />
                        : ''}

                        {selectedEsclateTo === 'Academic Coordinator' ?
                            <Autocomplete
                                id="academic-coordinator-autocomplete"
                                value={academicCoordinatorList.find(coordinator => coordinator._id === (currentBatch?.coordinator ?? selectedAssignee))}
                                options={academicCoordinatorList}
                                getOptionLabel={(option) => option?.name}
                                onChange={(event, newValue) => handleChangeAssignee(newValue)}
                                loading={loading}
                                renderInput={(params) => (
                                    <TextField {...params} label="Academic Coordinator *" />
                                )}
                                sx={{ marginTop: '15px' }}
                                size="small"
                            />
                        : ''}

                        {selectedEsclateTo === 'Accountant' ?
                            <Autocomplete
                                id="accountant-autocomplete"
                                value={accountantList.find(accountant => accountant._id === selectedAssignee)}
                                options={accountantList}
                                getOptionLabel={(option) => option?.name}
                                onChange={(event, newValue) => handleChangeAssignee(newValue)}
                                loading={loading}
                                renderInput={(params) => (
                                    <TextField {...params} label="Accountant *" />
                                )}
                                sx={{ marginTop: '15px' }}
                                size="small"
                            />
                        : ''}

                        {selectedEsclateTo === 'Mentor' ?
                            <Autocomplete
                                id="mentor-autocomplete"
                                value={mentorList.find(mentor => mentor._id === (currentBatch?.mentor ?? selectedAssignee))}
                                options={mentorList}
                                getOptionLabel={(option) => option?.name}
                                onChange={(event, newValue) => handleChangeAssignee(newValue)}
                                loading={loading}
                                renderInput={(params) => (
                                    <TextField {...params} label="Mentor *" />
                                )}
                                sx={{ marginTop: '15px' }}
                                size="small"
                            />
                        : ''}

                        {selectedEsclateTo === 'Centre Manager' ?
                            <Autocomplete
                                id="centre-manager-autocomplete"
                                value={centreManagerList.find(manager => manager._id === selectedAssignee)}
                                options={centreManagerList}
                                getOptionLabel={(option) => option?.name}
                                onChange={(event, newValue) => handleChangeAssignee(newValue)}
                                loading={loading}
                                renderInput={(params) => (
                                    <TextField {...params} label="Centre Manager *" />
                                )}
                                sx={{ marginTop: '15px' }}
                                size="small"
                            />
                        : ''}

                        <div style={{ textAlign: 'center', marginTop: '20px' }}>
                            <Button type="button" variant="outlined" sx={{ marginRight: '10px' }} onClick={() => setBatchForwardModal(false)}>Cancel</Button>
                            <Button type="button" variant="contained" onClick={forwardTicketTo}>Forward</Button>
                        </div>
                    </div>
                </Box>
            </Modal>

            <Modal
                open={batchCloseModal}
                onClose={() => setBatchCloseModal(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div>
                        <p>Issue: {selectedRow?.name}</p>
                        <p>Student: {selectedRow?.student?.firstName} {selectedRow?.student?.lastName}</p>
                        <p>Course: {selectedRow?.admission?.course?.name}</p>
                        <p>Category: {selectedRow?.category?.name}</p>
                        <p>Type: {selectedRow?.type}</p>
                        <TextField 
                            label="Remark"
                            value={remark}
                            onChange={(e) => setRemark(e.target.value)}
                            multiline
                            minRows={2}
                            fullWidth
                            required
                            sx={{ marginBottom: '20px' }}
                        />

                        <div style={{ textAlign: 'center', marginTop: '20px' }}>
                            <Button type="button" variant="outlined" sx={{ marginRight: '10px' }} onClick={() => setBatchCloseModal(false)}>Cancel</Button>
                            <Button type="button" variant="contained" onClick={closeTicket}>Close</Button>
                        </div>
                    </div>
                </Box>
            </Modal>

            <Modal
                open={batchApproveModal}
                onClose={() => setBatchApproveModal(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div>
                        <p>Issue: {selectedRow?.name}</p>
                        <p>Student: {selectedRow?.student?.firstName} {selectedRow?.student?.lastName}</p>
                        <p>Course: {selectedRow?.admission?.course?.name}</p>
                        <p>Category: {selectedRow?.category?.name}</p>
                        <p>Type: {selectedRow?.type}</p>
                        <TextField 
                            label="Remark"
                            value={remark}
                            onChange={(e) => setRemark(e.target.value)}
                            multiline
                            minRows={2}
                            fullWidth
                            required
                            sx={{ marginBottom: '20px' }}
                        />

                        <div style={{ textAlign: 'center', marginTop: '20px' }}>
                            <Button type="button" variant="outlined" sx={{ marginRight: '10px' }} onClick={() => setBatchApproveModal(false)}>Cancel</Button>
                            <Button type="button" variant="contained" onClick={approveTicket}>Approve</Button>
                        </div>
                    </div>
                </Box>
            </Modal>

            <Modal
                open={ticketActivityModal}
                onClose={() => setBatchForwardModal(false)}
            >
                <Box sx={style}>
                    <Box display="flex" alignItems="center">
                        <Box flexGrow={1}></Box>
                        <Box>
                            <IconButton onClick={() => setTicketActivityModal(false)}>
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    </Box>
                    <Box flexGrow={1} >Ticket Activity List</Box>
                    <List>
                        {ticketActivityList.map((activity, index) => {
                            if(activity.status !== 'Open') {
                                return <React.Fragment key={index}>
                                    {getActivities(activity)}
                                </React.Fragment>
                            }
                        })}
                    </List>
                </Box>
            </Modal>
        </div>
    );
};

export default MyTable;
